module.exports = __webpack_public_path__ + "img/partOne-left.b3c8349f.png";